module.exports = __webpack_public_path__ + "img/Nice.590e524f.png";